import { makeStyles, Theme, createStyles } from '@material-ui/core'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: 0,
    },
    content: {
      [theme.breakpoints.up('sm')]: {
        margin: '0px 200px',
      },
    },
  })
)
